import dayjs from "./dayjs";
import { TicketIdType } from "@/hooks/useCheckout";

export const priceFormatter = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",

    // These options can be used to round to whole numbers.
    // trailingZeroDisplay: "stripIfInteger", // This is probably what most people
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const priceFormatterCalendar = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",

    // These options can be used to round to whole numbers.
    // trailingZeroDisplay: "stripIfInteger", // This is probably what most people
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});

export const dateFormatter = (date: Date) =>
    date.toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZoneName: "short",
        timeZone: "America/Sao_Paulo",
    });

export const getStringDate = (date: Date | string): string => {
    if (typeof date === "string") {
        return date.split("T")[0];
    }
    if (date instanceof Date) {
        if (
            date.getHours() === 0 &&
            date.getMinutes() === 0 &&
            date.getSeconds() === 0 &&
            date.getMilliseconds() === 0
        ) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        }
        return dayjs(date).tz("America/Sao_Paulo").format("YYYY-MM-DD");
    }
    return "";
};

export const smallDateFormatter = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "America/Sao_Paulo",
});

export const hourFormatter = new Intl.DateTimeFormat("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "America/Sao_Paulo",
});

export const formatHoursRange = (rawHours: string, separator = " - ") => {
    const hours = rawHours.split("-");
    const [hour1, hour2] = hours.map((h) => h.split(":"));
    const hour1Formatted = `${hour1[0]}:${hour1[1]}`;
    const hour2Formatted = `${hour2[0]}:${hour2[1]}`;

    return `${hour1Formatted}${separator}${hour2Formatted}`;
};

export const getTicketTypeLabel = (ticketType: TicketIdType): string => {
    if (ticketType === "blue-premium") return "Blue Premium";
    if (ticketType === "blue") return "Blue";
    return ""
}

export const isDev = import.meta.env.DEV || window.location.href.includes("?debug");
